import Select from 'react-select';
import { useLiveQuery } from "dexie-react-hooks";
import { db, withExtras, withParents, withFormulas } from "../../Utils/Functions/Dexie-Setup";
import { tableConfigs } from "../../Utils/Functions/Table_Configs";
import { useMemo, useCallback } from "react"


//defaultValues, canCreate, 
const MultipleChoiceInput = ({ tableName, primaryKey, fieldName, label, disabled, ...rest }) => {
  const record = useLiveQuery(() => db[tableName].get(primaryKey), [primaryKey, tableName]);
  const field = useMemo(() => tableConfigs[tableName].fields.find(field => field.label === fieldName), [tableName, fieldName]);
  const options = useMemo(() => field.options.map(option => ({ label: option, value: option })), [field]);

  const onChange = useCallback((newValue) => db[tableName].update(primaryKey, { [fieldName]: newValue?.value ?? "", locallyUpdatedAt: Date.now() }))

  return (
    <>
      <label htmlFor={`${tableName}-${label}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
      <Select
        id={`${tableName}-${label}`}
        isClearable
        onChange={onChange}
        options={options}
        value={options?.find(({ value }) => value === record?.[fieldName]) ?? null}
        isDisabled={!!disabled}
        {...rest}
      />
    </>
  )
}

export default MultipleChoiceInput
